<script>
import BaseSubscriptionPlanFeatureList
  from "%/dynamic-component-editor/standard-components/subscription-card/BaseSubscriptionPlanFeatureList.vue";
import IconOptions from "%/dynamic-component-editor/bundles/icon-options";

export default {
  name: "SubscriptionPlanExcludedFeatures",
  elementPanelSettings: {
    displayName: "Excluded Features",
    displayIcon: "close",
    elementGroup: "subscriptionElements",
    elementType: "element",
  },
  extends: BaseSubscriptionPlanFeatureList,
  optionBundles: [
    new IconOptions({
      "default.icon": "material-symbols:close",
      "default.icon-variant": "subtle",
    }),
  ],
  computed: {
    featureTexts() {
      return this.entity.excludedFeatures;
    },
  },
};
</script>
